import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 25px 20px;
  height: 100%;

  form {
    height: 100%;
  }

  .btn-save-guest {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;

    width: 70px;
    height: 36px;

    background: rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    /* .sub-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;

    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12);
  } */
  }
  .input-container {
    height: 42px;
    margin: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .name-filter {
    width: 100%;
    height: 42px;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    padding: 8px 50px;
    opacity: 0.5;

    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    display: flex;
    align-items: center;

    /* Grey/Off Black */

    color: #0e0e2c;
  }
`;

export const Div = styled(Box)`
  h3 {
    padding: 0;
    margin: 0;
  }
`;

export const SectionHeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;
`;

export const PreviewArea = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  img {
    width: 30%;
    height: 156px;
    border-radius: 50%;
  }
`;

export const Typography = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const Section = styled(Box)`
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 20px;
  .input {
    width: 100%;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    height: 54.34px;
  }

  .input-permission {
    width: 100%;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    height: 54.34px;
    padding: 10px;
  }

  .btn-next {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: end;
  }

  .label {
    padding: 0;
    margin: 0;
  }
`;

export const HeaderCollapse = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const SectionDetails = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const Picture = styled(Box)`
  margin: 5px 0px 0px 0px;
  width: 100px;
  height: 100px;
  border: 1px solid #323232;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
`;

export const InputSection = styled(Box)`
  .inputMember {
    width: 100%;
  }
  .add-logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
    height: 60px;
    border: 1px dashed #bdbdbd;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 20px;
  }
`;
